import { Anchor, Card, Text, Center, Loader, Stack } from "@mantine/core";
import { NavLink, useParams } from "react-router-dom";
import BreadcrumbsNavigation from "@/components/breadcrumbs-navigation";
import EmbaixadorPessoaForm from "@/modules/embaixadores-pessoas/components/embaixador-pessoa-form";
import ProjetosRelacionadosCard from "@/modules/embaixadores-pessoas/components/projetos-relacionados-card";
import { TEmbaixadorPessoaForm } from "@/modules/embaixadores-pessoas/firestore";
import useGetEmbaixadorPessoaById from "@/modules/embaixadores-pessoas/hooks/useGetEmbaixadorPessoaById";
import embaixadorPessoaSchema from "@/modules/embaixadores-pessoas/schema/embaixador-pessoa-schema";

const EmbaixadorFormPage = () => {
  const { embaixadorId } = useParams<"embaixadorId">();
  const { data: embaixadorPessoa, isLoading } = useGetEmbaixadorPessoaById(embaixadorId);

  if (isLoading && embaixadorId) {
    return (
      <Center h={400}>
        <Loader />
      </Center>
    );
  }

  const embaixadorPessoaForm = embaixadorPessoa
    ? {
        ...embaixadorPessoa,
        telefone: embaixadorPessoa.telefone || "",
        email: embaixadorPessoa.email || ""
      }
    : (embaixadorPessoaSchema.getDefault() as TEmbaixadorPessoaForm);

  return (
    <>
      <BreadcrumbsNavigation>
        <Anchor component={NavLink} to="/embaixadores">
          Embaixadores
        </Anchor>
        <Text c="dimmed" mt={-6}>
          {embaixadorId ? embaixadorPessoa?.nome || "Editar embaixador" : "Novo embaixador"}
        </Text>
      </BreadcrumbsNavigation>

      <Stack gap="md">
        <Card withBorder>
          <EmbaixadorPessoaForm embaixadorPessoa={embaixadorPessoaForm} />
        </Card>

        <ProjetosRelacionadosCard embaixadorPessoaId={embaixadorId} />
      </Stack>
    </>
  );
};

export default EmbaixadorFormPage;
